var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{attrs:{"id":"nav"}},[_c('NavBar')],1),_c('router-view',{attrs:{"id":"inner-body"}}),_c('footer',[_vm._v(" 2017-2026 - Clément Besnier ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }